<template>
  <div class="content">
    <HeaderProductResale
      title="Adicionar Produtos"
      text="Selecione os produtos para adicionar no seu estoque"
      actionTitle=""
      :haveAction="false"
      :haveBack="true"
      :resaleId="this.userId"
      :showStockSettings="true"
      ref="headerProductResaleAddProduct"
    >
      <v-btn
        outlined
        class="ml-3"
        style="border-radius: 10px; width: 250px"
        @click="getExcel"
      >
        Exportar SKU's
      </v-btn>

      <v-btn
        outlined
        class="ml-3 mt-4"
        style="border-radius: 10px; width: 250px"
        @click="openPicker"
      >
        Importar SKU's
      </v-btn>
    </HeaderProductResale>

    <v-file-input
      id="excel-input"
      class="d-none"
      accept=".xlsx"
      @change="importExcel"
    ></v-file-input>

    <v-container style="max-width: unset" class="pa-6 pt-2">
      <v-card
        transition="scale-transition"
        v-if="true"
        class="d-column mt-0 mb-6 py-2"
        elevation="0"
        color="#FFFFFF"
        style="border-radius: 6px"
      >
        <!-- Primeira linha de filtro -->
        <v-row class="py-3 px-6 ma-0">
          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="3"
            md="3"
            sm="6"
          >
            <v-text-field
              outlined
              class="px-0"
              style="
                border: 1px solid #979797;
                border-radius: 7.5px;
                width: 100%;
              "
              color="black"
              background-color="#F5F5F5"
              hide-details
              placeholder="Nome do Produto ou SKU"
              v-model="filter.product"
              attach
              v-on:keyup="filterTable"
              :loading="loading"
            >
              <template v-slot:append>
                <v-icon class="pt-0" color="normalred" size="26"
                  >mdi-magnify</v-icon
                >
              </template>
            </v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-autocomplete
              color="black"
              clearable
              v-model="filter.productCategory"
              attach
              :items="categories"
              item-text="categoryName"
              item-value="categoryId"
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Categoria"
              @change="filterTable"
              :loading="loading"
            ></v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-text-field
              color="black"
              clearable
              v-model="filter.productType"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Tipo"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="3"
            md="4"
            sm="6"
          >
            <v-btn
              :outlined="!showAllFilters"
              block
              color="black"
              dark
              elevation="0"
              height="56"
              style="border-radius: 7.5px"
              @click="showAllFilters = !showAllFilters"
            >
              <v-icon class="ma-0 pa-0">mdi-filter</v-icon>
              Abrir todos os filtros
            </v-btn>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
          >
            <v-btn
              block
              outlined
              height="56"
              style="border-radius: 7.5px"
              @click="reset"
              >Limpar filtros
            </v-btn>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-text-field
              color="black"
              clearable
              v-model="filter.productApplication"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Aplicação"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-text-field
              color="black"
              v-model="filter.maxValue"
              :key="maxValueKey"
              v-money="money"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              label="Valores Até"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-autocomplete
              color="black"
              clearable
              v-model="filter.order"
              :items="orders"
              item-text="text"
              item-value="value"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              placeholder="Ordem alfabetica"
              @change="filterTable"
              :loading="loading"
            ></v-autocomplete>
          </v-col>

          <v-col
            class="d-flex flex-column align-start my-1 py-1"
            cols="12"
            lg="2"
            md="2"
            sm="6"
            v-if="showAllFilters"
          >
            <v-text-field
              color="black"
              v-model="filter.value"
              v-money="money"
              :key="valueKey"
              attach
              outlined
              append-icon="mdi-chevron-down"
              hide-details
              style="width: 100%; border-radius: 7.5px"
              required
              label="Valor"
              v-on:keyup="filterTable"
              :loading="loading"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card>

      <v-card
          v-if="resaleId && resale && resale.nameFantasy"
          transition="scale-transition"
          class="d-column mt-0 mb-6 py-2"
          elevation="0"
          color="#FFFFFF"
          style="border-radius: 6px"
      >
        <v-row class="py-1 px-6 ma-0" cols="12">
          <v-col cols="12">
            <h3>Cadastrar produtos para a revenda: <strong>{{resale.nameFantasy}}</strong></h3>
          </v-col>
        </v-row>
      </v-card>
      <!-- Cards com os produtos -->
      <v-row no-gutters>
        <v-col
          v-for="item in products"
          :key="item.productId"
          class="pb-4"
          style="text-align: -webkit-center"
          cols="12"
          sm="4"
          md="3"
        >
          <ImageCard
            :item="item"
            :env_url="env_url"
            @action1="detailsProduct(item)"
            @action2="addProduct(item)"
            :key="dialogKey"
          />
          <!-- @action2="goToAdd(item)" -->
        </v-col>
      </v-row>
      <!-- Paginação -->
      <section class="ma-0 pa-0">
        <Pagination
            v-if="totalItems > pageSize"
            :currentPage="currentPage"
            :totalItems="totalItems"
            :page="page"
            :pageSize="pageSize"
            :totalPages="totalPages"
            @back-page="backPage"
            @next-page="nextPage"
        >
        </Pagination>
      </section>
    </v-container>

    <!-- Dialog DETAILS  -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="detailsDialog"
      max-width="950px"
    >
      <DetailsProduct
        :product="this.currentProduct"
        title="Detalhar Revenda"
        @action="detailsDialog = false"
        @close="detailsDialog = false"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>

    <!-- Dialog DETAILS 2 -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="details2Dialog"
      max-width="980px"
    >
      <Details2Product
        :productId="this.currentProduct.productId"
        @action="editProduct(currentProduct)"
        @close="details2Dialog = false"
        @closeNoLoading="closeNoLoading"
        :key="dialogKey"
      />
    </v-dialog>
  </div>
</template>

<style scoped>
.content {
  background: #e5e5e5;
}

.v-dialog--active {
  box-shadow: none;
}

.imgProduct {
  background-position: center center;
  border-radius: 15%;
}

.item {
  background: #424242 !important;
}

.item span {
  font-size: 1.05rem;
  color: #fff;
}

.back {
  background: #e9e9e9 !important;
  max-width: unset;
}

.filterAutocomplete {
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
}

.table-button {
  font-weight: bold;
  transition: 300ms;
}

.table-button:hover {
  background: #2d3038;
  color: white !important;
}

.table-button:focus {
  background: #444854;
  color: white !important;
}

@media (max-width: 330px) {
  .v-menu__content {
    left: 15px !important;
    max-width: unset;
  }
}

@media (max-width: 860px) {
  .table-header {
    display: none;
  }
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import HeaderProductResale from "./components/HeaderProductResale.vue";
import DetailsProduct from "./components/DetailsProduct.vue";
import Details2Product from "./components/Details2Product.vue";
import ImageCard from "./components/ImageCard.vue";
import { VMoney } from "v-money";

import Vue from "vue";
import Pagination from "@/views/pages/components/Pagination.vue";

export default {
  name: "ProductSelect",

  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.userId = this.user.id
    const {resaleId} = this.$route.query
    this.resaleId = resaleId ? resaleId : null;
    if(this.resaleId){
      await this.getResale()
    }
    this.getCategories();
    const jsonFilters = localStorage.getItem("filters-sku-resale");
    if (jsonFilters) {
      this.filter = JSON.parse(localStorage.getItem("filters-sku-resale"));
      this.page = this.filter.page;
    }
    await this.updateTable();
    this.env_url = process.env.VUE_APP_BASE_URL;
    this.$refs.headerProductResaleAddProduct.getResale()
  },

  data: () => ({
    user: null,
    userId: null,
    categories: [],
    showAllFilters: false,
    details2Dialog: false,
    env_url: "",
    currentProduct: {},
    resaleId: null,
    resale: null,
    detailsDialog: false,
    importDialog: false,
    products: [],
    productsId: [],
    show: false,
    dialog: false,
    closeNoLoading: false,
    addDialog: false,
    aboutDialog: false,
    dialogKey: false,
    loading: false,
    isLoading: false,
    page: 1,
    totalPages: 1,
    totalItems: 1,
    currentPage: 1,
    pageSize: 15,
    sizes: [15, 30, 90, 180],
    apiService: new ApiService(),
    filter: {
      page: 1,
      pageSize: 15,
      product: "",
      productCategory: 0,
      productType: "",
      productApplication: "",
      maxValue: "",
      value: "",
    },
    orders: [
      {
        text: "Crescente",
        value: 0,
      },
      {
        text: "Decrescente",
        value: 1,
      },
    ],
    money: {
      decimal: ",",
      thousands: ".",
      precision: 2,
      masked: false,
    },
    maxValueKey: false,
    valueKey: false,
    status: [
      { label: "Em estoque", value: 0 },
      { label: "Fora de estoque", value: 1 },
    ],
    error: false,
    message: "",
  }),

  components: {
    Pagination,
    HeaderProductResale,
    DetailsProduct,
    ImageCard,
    Details2Product,
  },

  directives: { money: VMoney },

  methods: {
    openPicker() {
      document.getElementById("excel-input").click();
    },

    async importExcel() {
      let file;
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = () => {
        file = reader.result;
        this.doExcelImport(file);
      };
    },

    async doExcelImport(media) {
      this.apiService
        .post("resaleproductsku/excel/import", { media })
        .then((resp) => {
          this.$toast.success("Excel importado com sucesso");
          this.updateTable();
        });
    },

    async getExcel() {
      await this.apiService
        .post(`resaleproductsku/excel`, this.filter)
        .then((response) => {
          var excelResult = `data:application/octet-stream;base64,${response}`;
          const link = document.createElement("a");
          link.href = excelResult;
          link.setAttribute("download", "skus.xlsx");
          document.body.appendChild(link);
          link.click();
        });
    },

    getCategories() {
      this.apiService.get("category/list").then((response) => {
        this.categories = response;
      });
    },

    async getResale() {
      this.apiService.get(`resale/get-one?id=${this.resaleId}`).then((response) => {
        this.resale = response;
        this.userId = this.resale.id
      });
    },

    showSuccess(message) {
      this.$emit("show", message);
    },

    detailsProduct(item) {
      this.currentProduct = item;
      this.dialogKey = !this.dialogKey;
      this.details2Dialog = true;
    },

    async goToAddProduct(item) {
      await this.$router.push({
        path:
          "/product-addresale?isEditing=true&id=" +
          item.productId +
          "&product=" +
          item.productName,
      });
    },

    async goToAdd(item) {
      await this.$router.push({
        path:
          "/product-addresale?isEditing=true&id=" +
          item.productId +
          "&product=" +
          item.productName,
        params: item,
      });
    },

    async addProduct(item) {
      localStorage.setItem("filters-sku-resale", JSON.stringify(this.filter));
      const query = this.resaleId ? {
        id: item.productId,
        product: item.productName,
        resaleId: this.resaleId
      } :
      {
        id: item.productId,
        product: item.productName
      };

      await this.$router.push({
        path:'product-addresale',
        query
      });
    },

    async configProduct(item) {
      await this.$router.push({
        path: "/products-config",
      });
    },

    async editProduct(item) {
      localStorage.setItem("filters-sku-resale", JSON.stringify(this.filter));
      await this.$router.push({
        path: `/product-addresale?id=${item.productId}&product=${item.productName}`,
        params: item,
      });
    },

    closeDialog() {
      this.dialog = false;
      this.editDialog = false;
      this.updateTable();
    },

    filterTable() {
      this.loading = true;
      this.page = 1;
      this.filter.pageSize = this.pageSize;
      this.filter.page = this.page;
      this.updateTable();
      this.filterDialog = false;
    },

    async updateTable() {
      this.loading = true;
      this.isLoading = true;

      this.filter.maxValue =
        typeof this.filter.maxValue == "string"
          ? parseFloat(this.filter.maxValue.replace(".", "").replace(",", "."))
          : this.filter.maxValue;

      this.filter.value =
        typeof this.filter.value == "string"
          ? parseFloat(this.filter.value.replace(".", "").replace(",", "."))
          : this.filter.value;

      await this.apiService
        .post(`product/listActive`, this.filter)
        .then((response) => {
          this.totalPages = response.pager.totalPages;
          this.totalItems = response.pager.totalItems;
          this.currentPage = response.pager.currentPage;
          this.products = response.products;

          this.loading = false;
          this.isLoading = false;
        });
    },

    async backPage() {
      this.page -= 1;
      this.filter.page = this.page;
      await this.updateTable();
    },

    async nextPage() {
      this.page += 1;
      this.filter.page = this.page;
      await this.updateTable();
    },

    reset() {
      localStorage.removeItem("filters-sku-resale");
      (this.productName = null),
        (this.productType = null),
        (this.filter = {
          page: 1,
          pageSize: 15,
        });
      this.page = 1
      this.updateTable();
      this.filterDialog = false;
    },
  },

  watch: { },
};
</script>
